const globalConstants = {
    poisLimit: 100,
    posRadius: 50,
    driverRoleName: "Vozač",
    workMachineVehicleType: "Work machine"
}

const allVehicleStatuses = [
    { Status: "Moving", Id: 1 },
    { Status: "Stopped", Id: 2},
    { Status: "Inactive", Id: 3},
    { Status: "StoppedTurnedOn", Id: 4}
]

const poiTypes = [
    { Name: "Poi", Id: 1 },
    { Name: "Pos", Id: 2 },
    { Name: "Warehouse", Id: 3 },
]

export { globalConstants, allVehicleStatuses, poiTypes }